import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  divCom: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    height: "fit-content",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  divCom2: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  divToggle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "15px",
    padding: "10px 12px",
    borderRadius: "12px",
    backgroundColor: colors.elevatedSurface,
    border: `1px solid ${colors.borderLight}`,
  },
  toggleTexts: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginTop: "5px",
  },
});

export default useStyles;
